export const detectHtmlInComment = (content: string): boolean => {
  const trimmed = content.trim();

  return (
    /^<\/?[a-z][\s\S]*>/.test(trimmed) || // starts with HTML tag
    /<\/[a-z]+>/i.test(trimmed) || // contains closing tags
    /&lt;\/?[a-z]/i.test(trimmed) // escaped HTML
  );
};
